module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_vm._v("Chapter 1: Your Questions About Gut Health, Answered")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1"
    }
  }, [_c('em', [_vm._v("What is the gut and what does it do?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev2"
    }
  }, [_c('em', [_vm._v("What does it mean to have a healthy gut?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev3"
    }
  }, [_c('em', [_vm._v("What are gut bacteria?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev4"
    }
  }, [_c('em', [_vm._v("Is there a relationship between certain gut bacteria and disease?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev5"
    }
  }, [_c('em', [_vm._v("What are the symptoms of an unhealthy gut?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev6"
    }
  }, [_c('em', [_vm._v("What conditions and diseases are associated with the gut?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev7"
    }
  }, [_c('em', [_vm._v("Is leaky gut syndrome a real problem?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev8"
    }
  }, [_c('em', [_vm._v("What are the causes of an unhealthy gut?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev9"
    }
  }, [_c('em', [_vm._v("How are gut issues treated?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev10"
    }
  }, [_c('em', [_vm._v("Can a detoxifying diet help my gut?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 2: The Nutrition Connection and Beyond")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Our Relationship with Carbohydrates")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Gassy Problem")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Uncovering Beneficial Dietary Gut Supplements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Food Allergies, Intolerances, Sensitivities, and Your Gut")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The FODMAP Diet Approach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 3: Your Five-Step Nutrition and Lifestyle Solution")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Step 1. Commit to Cleaner Eating")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Step 2. Boost Your Daily Fiber Intake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Step 3. Limit Added Sugar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Step 4. Opt for Whole Grains")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Step 5. Reach and Maintain a Healthy Weight")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Other Gut-Favorable Lifestyle Changes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 4: 10 Foods to Avoid and 10 Foods to Include for a Healthier Gut")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("10 Foods to Avoid")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("10 Foods to Include")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Gut-Friendly Herbs and Spices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 5: Menu Planning and Shopping Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Menu Planning Tips")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Navigating the Supermarket")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Using Food Labels for a Healthier Gut")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Put It All Together")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Nutrient Content Claims")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Health Claims")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Allergan Listings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 6: 14-Day Menu Guide and Stocking Your Kitchen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("14-Day Menu Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stocking Your Kitchen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/resource#resource",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Your Best Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author#author",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("About the Author")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 78
// module chunks = 0